import { useEffect, useRef } from "react";
import { useBlocker } from "react-router";
import { useConfirm } from "./ConfirmDialog";
import { useAppPreferences } from "../lib/preferences";

export function NavigationBlocker({ isDirty }: { isDirty: boolean }) {
  const { t } = useAppPreferences();
  const { confirm, dialog } = useConfirm();
  const blocker = useBlocker(isDirty);
  const blockerRef = useRef(blocker);
  blockerRef.current = blocker;
  const confirmRef = useRef(confirm);
  confirmRef.current = confirm;
  const tRef = useRef(t);
  tRef.current = t;
  const pendingRef = useRef(false);

  useEffect(() => {
    if (blocker.state !== "blocked") {
      pendingRef.current = false;
      return;
    }

    if (pendingRef.current) {
      return;
    }
    pendingRef.current = true;

    let cancelled = false;
    void confirmRef.current!({
      confirmButtonLabel: tRef.current!("Discard changes"),
      description: tRef.current!(
        "You have unsaved changes. Leaving this page will discard them.",
      ),
      title: tRef.current!("Discard unsaved changes?"),
    }).then((shouldDiscard) => {
      if (cancelled) {
        return;
      }
      if (shouldDiscard) {
        blockerRef.current.proceed?.();
      } else {
        blockerRef.current.reset?.();
      }
    });

    return () => {
      cancelled = true;
    };
  }, [blocker.state]);

  return dialog;
}
